import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { useEffect } from 'react'
import { setTitlePage } from '../../Functions'

const Formularios = () => {

  useEffect(() => {
    setTitlePage('Formularios');
  }, [])

  return (

      <div className="card">
        <div className="card-body">
          
          <div className="section">
            <span className="fs-1 text-amsm">
              Formularios Programas Atención Médica
            </span>
            <table className="table-bordered table table-striped table-hover table-form" style={{marginTop: '20px'}}>

              <tbody className="fs-2 text-gray-700"><tr>
                <td>Banmedica</td>
                <td className="text-center td_align td-form" width="20%">
                  <a target="_blank" href="https://prestadores.banmedica.cl/wp-content/uploads/2018/08/Programa-atencion-medica-BM.pdf" rel="noreferrer">
                    <img src={toAbsoluteUrl('/media/icons/892303.png')} style={{ marginLeft: '10px', maxWidth: '32px' }} alt="Descargar" />
                  </a>
                </td>
              </tr>
                <tr>
                  <td>Vida tres</td>
                  <td className="text-center td-form">
                    <a target="_blank" href="https://prestadores.vidatres.cl/wp-content/uploads/2018/08/Programa_de_Atenc-_Me%CC%81dica_VT-1.pdf" rel="noreferrer">
                      <img src={toAbsoluteUrl('/media/icons/892303.png')} style={{ marginLeft: '10px', maxWidth: '32px' }} alt="Descargar" />
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>Cruz Blanca</td>
                  <td className="text-center td-form">
                    <a target="_blank" href="http://sitio.cruzblanca.cl/ProgramaAtencionMedica/Inicio.aspx" rel="noreferrer">
                      <img src={toAbsoluteUrl('/media/icons/892303.png')} style={{ marginLeft: '10px', maxWidth: '32px' }} alt="Descargar" />
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>Consalud</td>
                  <td className="text-center td-form">
                    <a target="_blank" href="https://formulariopam.consalud.cl/?_ga=2.74499281.2107153989.1582834879-597664204.1582834879" rel="noreferrer">
                      <img src={toAbsoluteUrl('/media/icons/892303.png')} style={{ marginLeft: '10px', maxWidth: '32px' }} alt="Descargar" />
                    </a>
                  </td>
                </tr>

                <tr>
                  <td>Fundación</td>
                  <td className="text-center td-form">
                    <a target="_blank" href="https://intranet.amsm.cl/images/fundacion.pdf" rel="noreferrer">
                      <img src={toAbsoluteUrl('/media/icons/892303.png')} style={{ marginLeft: '10px', maxWidth: '32px' }} alt="Descargar" />
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>Fonasa</td>
                  <td className="text-center td-form">
                    <a target="_blank" href="https://intranet.amsm.cl/images/fonasa.pdf" rel="noreferrer">
                      <img src={toAbsoluteUrl('/media/icons/892303.png')} style={{ marginLeft: '10px', maxWidth: '32px' }} alt="Descargar" />
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>Aviso de Cuenta AMSM</td>
                  <td className="text-center td-form">
                    <a target="_blank" href="https://intranet.amsm.cl/images/aviso-cuenta.pdf" rel="noreferrer">
                      <img src={toAbsoluteUrl('/media/icons/892303.png')} style={{ marginLeft: '10px', maxWidth: '32px' }} alt="Descargar" />
                    </a>
                  </td>
                </tr>

              </tbody></table>
          </div>

          <div className="section">
            <span className="fs-1 text-amsm">
            Seguro de Salud Vida Cámara
            </span>
              <table className="table-bordered table table-striped table-hover table-form" style={{marginTop: '20px'}}>
              <tbody className="fs-2 text-gray-700"><tr>
                <td>Formulario Reembolso Gastos de Salud</td>
                <td className="text-center td-form" width="20%">
                  <a target="_blank" href="https://intranet.amsm.cl/images/gastos-salud.pdf" rel="noreferrer">
                    <img src={toAbsoluteUrl('/media/icons/892303.png')} style={{ marginLeft: '10px', maxWidth: '32px' }} alt="Descargar" />
                  </a>
                </td>
              </tr>

                <tr>
                  <td>Formulario Reembolso Gastos Dentales</td>
                  <td className="text-center td-form">
                    <a target="_blank" href="https://intranet.amsm.cl/images/gastos-dentales.pdf" rel="noreferrer">
                      <img src={toAbsoluteUrl('/media/icons/892303.png')} style={{ marginLeft: '10px', maxWidth: '32px' }} alt="Descargar" />
                    </a>
                  </td>
                </tr>

                <tr>
                  <td>Tutorial para Reembolso en Línea</td>
                  <td className="text-center td-form">
                    <a target="_blank" href="https://intranet.amsm.cl/images/tutorial-vida-camara.pptx" rel="noreferrer">
                      <img src={toAbsoluteUrl('/media/icons/892303.png')} style={{ marginLeft: '10px', maxWidth: '32px' }} alt="Descargar" />
                    </a>
                  </td>
                </tr>
              </tbody></table>
          </div>
        </div>
      </div>

  )
}

export default Formularios